export default {
  nav: {
    connectWallet: "连接钱包",
    connected: "已連接",
    switchLanguage: "切换语言",
    menu: {
      extinct: "The Lost Beast",
      iceAge: "冰河世纪",
      cretaceous: "白垩纪",
      market: "自由市场",
      nftGame: "NFT游戏",
      museum: "博物馆",
      irlEvents: "IRL活动",
      announcement: "公告",
      more: "更多",
      whitepaper: "白皮书",
      purchase: "购买NFT",
    },
  },
  home: {
    iceAge: "冰河世纪",
    cretaceous: "白垩纪",
    year: "年",
    month: "月",
    day: "日",
    individual: "个",
    title: "世界不是我们从祖先那里继承来的，而是从后代手中借来的",
    subTitle:
      "消逝的巨兽 是一个融合数字艺术、区块链技术与环保理念的开创性NFT生态项目。以珍稀动物为主题，我们希望以创新的方式唤醒人们对濒危动物和环境保护的关注，让灭绝的巨兽在虚拟世界中焕发新生。通过讲述这些动物的故事，我们试图为它们重建失落的记忆，并激励每一个参与者为自然保护贡献自己的力量。",
    info:
      "“只有当最后一棵树被砍倒，最后一条河被污染，最后一条鱼被捕捉，人类才会发现，金钱无法吃喝。”——克里族谚语。这句经典的话语正是 消逝的巨兽 想要传递的理念：保护自然不仅是对生态的守护，更是对人类未来的承诺。\n" +
      "这个项目不仅是一场数字收藏的旅程，更是一个全球性的环保倡议。依托Web3技术，我们打造了一个贯穿线上与线下的多维度生态系统，涵盖虚拟博物馆、互动链游及公益合作。每一位参与者都将成为这一环保行动的重要一环，与我们共同书写关于自然保护的未来篇章。",
    ourSeries: "我们的系列",
    comingSoon: "敬请期待",
    moreEvents: "更多活动",
    roadmap: "项目线路图",
    OfficialWebsiteRelease: "火爆销售",
    OfficialWebsiteReleaseTime: "2025年1月20日",
    time: "2025年1月",
    similarFate:
      "冰河世纪首批NFT系列涵盖了10种标志性动物，每一种都承载着深刻的生态警示。猛犸象象征气候变化的剧烈影响，其灭绝提醒我们应坚定应对气候危机，避免现代物种重蹈覆辙",
    firstBatch: "神秘嘉宾",
    toBeSoon: "敬请期待",
    sell: "发售",
    FreeMarketRelease: "自由市场",
    ChainTravel: "链游",
    goBuy: "立即购买",
    // iceAge: {
    //   time: "2025年2月",
    //   name: "冰河世纪",
    //   nft: "100个NFT",
    // },
    // cretaceous: {
    //   time: "敬請期待",
    //   name: "白堊紀",
    //   nft: "100个NFT",
    // },
    projectRoadmap: "項目路線圖",
    timeline: {
      websiteRelease: "官網發布",
      websiteReleaseTime: "2024年12月24日",
      nftSale: "首批 NFT 發售",
      nftSaleTime: "2025年1月20日",
      marketRelease: "自由市場發布",
      marketReleaseTime: "敬請期待",
      gameRelease: "鏈遊",
      gameReleaseTime: "敬請期待",
    },
    quote: "NEVER GONNA GIVE YOU UP.",
    copyright: "2024",
  },
  child: {
    title: "冰河世纪：寒冰中的警示",
    subTitle:
      "冰河世纪 是 消逝的巨兽 的第一个子项目，以冰河时代灭绝的动物为核心，重新构建它们的故事，唤醒人类对环境保护的思考。冰河时期是地球历史上一个充满奇迹与变革的时代。随着气候变化与生态失衡，许多伟大的动物逐渐消失，成为记忆中的象征。它们的灭绝不仅提醒我们自然的脆弱，也警示着现代社会所面临的环境挑战。",
    Climate: "气候危机与生态失衡的警示",
    ClimateContent:
      "冰河世纪首批NFT系列涵盖了10种标志性动物，每一种都承载着深刻的生态警示。猛犸象象征气候变化的剧烈影响，其灭绝提醒我们应坚定应对气候危机，避免现代物种重蹈覆辙；剑齿虎的消亡展现了生态失衡对顶级捕食者的毁灭性影响，警示我们需保护食物链的完整性；恐鸟的灭绝直接反映了人类活动对生态系统的破坏，提醒保护栖息地对维护生物多样性至关重要。",
    BalanceTitle: "栖息地与自然平衡的呼声",
    BalanceContent:
      "披毛犀的消亡揭示了人类过度开发对环境的毁灭性后果，强调可持续发展的重要性；巨型树懒缓慢的生活方式象征生态平衡，其灭绝警示我们自然失衡虽缓慢却不可逆转；洞熊的消失表明栖息地丧失是物种灭绝的主要原因，保护自然环境是生命延续的根本。",
    Ecosystems: "生物多样性与生态系统的守护",
    EcosystemsContent:
      "巨鹰的故事象征了天空生态的脆弱，其灭绝警醒我们关注飞行动物及其栖息地的保护；大角鹿的优雅与灭绝揭示了生态的美丽与脆弱，强调保护生物多样性的重要性；巨河狸作为湿地生态的重要构建者，其灭绝象征水资源保护的迫切性；冰原狼的协作与生态适应能力是自然平衡的象征，其消失则体现了环境恶化的严重后果，提醒人类需共同努力守护自然。",
    descendants: "世界不是我们从祖先那里继承来的，而是从后代手中借来的",
    descendantsTitle:
      "世界不是我们从祖先那里继承来的，而是从后代手中借来的\n" +
      "消逝的巨兽 是一次向过去致敬、对未来负责的行动。对数字技术与环保理念的一次深度融合，它不仅为灭绝动物赋予新的生命形式，更为人类敲响了生态保护的警钟。\n" +
      "通过 冰河世纪 系列NFT，您将成为保护自然的一部分。无论是加入虚拟博物馆、探索链游生态，还是支持线下环保行动，每一个选择都将助力地球的未来。加入我们，用数字艺术书写一部属于自然保护的未来史诗，让生命的微光永不消逝！",
    Ecological: "濒危物种的生态警示与守护呼声",
    EcologicalContent:
      "冰河世纪首批NFT系列涵盖10种标志性动物，每种动物的灭绝都承载着重要的生态警示：猛犸象、剑齿虎和恐鸟提醒我们气候变化、生态失衡和人类活动对自然的毁灭性影响；披毛犀、巨型树懒和洞熊揭示了可持续发展和保护栖息地对于自然平衡的重要性；巨鹰、大角鹿、巨河狸和冰原狼象征了天空、陆地与湿地生态的脆弱与美丽，警示人类保护生物多样性、水资源和自然平衡的迫切需求。这些动物的故事共同呼吁人类采取行动，守护我们的地球家园。",
    ourDescendants: "世界不是我们从祖先那里继承来的，而是从后代手中借来的",
    ourDescendantsContent:
      "消逝的巨兽 是一次向过去致敬、对未来负责的行动。对数字技术与环保理念的一次深度融合，它不仅为灭绝动物赋予新的生命形式，更为人类敲响了生态保护的警钟。\n" +
      "通过 冰河世纪 系列NFT，您将成为保护自然的一部分。无论是加入虚拟博物馆、探索链游生态，还是支持线下环保行动，每一个选择都将助力地球的未来。加入我们，用数字艺术书写一部属于自然保护的未来史诗，让生命的微光永不消逝！",
  },
  notice: {
    title: "公告",
    noData: "暫無數據",
    readMore: "閱讀更多",
    date: "日期",
    search: "搜索",
    back: "返回",
    noMore: "没有更多了",
    loading: "加载中...",
    category: {
      all: "全部",
      news: "新聞",
      updates: "更新",
      events: "活動",
    },
  },
  market: {
    Assetagreement: "资产协议",
    PublicAssetChain: "资产公链",
    ConfirmationOfPurchase: "确认购买",
    Ethereum: "以太坊",
    ContractAddress: "合约地址",
    owner: "拥有者",
    sellingPrice: "售价",
    return: "返回",
    shareLink: "分享链接",
    TransactionHistory: "交易历史",
    search: "搜索",
    detail: "详情",
    name: "名称",
    Price: "价格",
    Time: "时间",
    Operation: "操作",
    sellOut: "售罄",
    PleaseConnectWallet: "请连接钱包",
  },
  whitepaper: {
    title: "The Lost Beasts NFT经济学",
    content: {
      w1: "The Lost Beasts是一系列符合 ERC-721 代币标准的数字代币。The Lost Beasts 没有任何功能、用途或内在价值，也没有任何财务回报、利润、利息或股息的承诺或预期。",

      w2: "The Lost Beasts 没有发展计划，也没有任何承诺或预期会为 The Lost Beasts 开发任何生态系统。",

      w3: "The Lost Beasts 完全无用，仅供娱乐用途。",

      w4: "为避免误解，并且不限于上述内容，The Lost Beasts 并不且不意图：",

      w5: "• 成为公众（或公众的某部分）接受的交换媒介，用于支付商品或服务，或偿还债务；",

      w6: "• 被设计或意图供任何人用作支付任何商品或服务的手段；",

      w7: "• 赋予持有人将 The Lost Beasts系列NFT兑换为商品或服务的权利；",

      w8: "• 作为货币（包括电子货币）的代表；",

      w9: "• 作为资本市场产品、证券、股份、债券、集体投资计划的单位、衍生品合约、商品或任何其他金融工具或投资的数字表示；",

      w10: "• 作为任何司法管辖区的资本市场产品、证券、股份、债券、集体投资计划单位、衍生品合约、商品或其他金融工具或投资；",

      w11: "• 代表任何实体、企业或事业的股权、参与权、权利（包括但不限于投票权）、头衔、权益或经营权；",

      w12: `• 代表在"The Lost Beasts"生态系统中行使投票权的权利；`,

      w13: "• 代表任何费用、股息、收入、利润或投资回报的权利；",

      w14: "• 代表差价合约或其他合约下的任何权利，其目的或声称的目的为获取利润或避免损失；",

      w15: "• 可退款或兑换为现金（或任何其他数字资产的等值价值）；",

      w16: "• 代表任何债务。",

      w17: "The Lost Beasts不保证或承诺会在任何交易所上市。",

      w18: "免责声明",

      w19: "本白皮书和网站仅供一般信息参考，既不构成招股说明书、要约文件，也不构成证券、资本市场产品或数字支付代币的要约，或投资的招揽，也不是出售任何产品、工具或资产（无论是数字资产还是其他形式）的要约。",

      w20: "这里的信息可能不全面，也不意味着任何合同关系的组成部分。不能保证信息的准确性或完整性，亦未提供或声称提供任何此类保证或声明。",

      w21: "信息更新与声明",

      w22: "白皮书中的信息仅截至封面上所注明的版本日期。关于任何代币销售、The Lost Beasts 功能、财务状况及未来规划的信息可能会随时更改，白皮书或网站中的信息可能因此过时，The Lost Beasts成员无义务因此更新或修正本文件。",
    },
  },
};
